import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense, useEffect } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import PageTitle from '@helpers/PageTitle';
import Header from '@domain/Header/Header';
import AccountScreen from '@domain/Account/AccountScreen';
import PrivateRoute from '@components/Route/PrivateRoute';
import useTrackNavigation from '@hooks/useTrackNavigation';
import ErrorPage from '@domain/Errors/components/ErrorPage';
import { styled } from '@mui/material/styles';
import WithdrawalOnlyLandingPageScreen from '@domain/LandingPage/WithdrawalOnlyLandingPageScreen';
import useTrackPageView from '@hooks/useTrackPageView';
import { useUserState } from '@context/UserContext';
import useRootRedirectUrl from '@hooks/useRootRedirectUrl';
const Error404 = lazy(() => import('./domain/Errors/components/Error404'));
const UserScreen = lazy(() => import('./domain/User/UserScreen'));
const ChangeEmailConfirmationScreen = lazy(() => import('@domain/Account/ChangeEmailConfirmation'));
const AboutPage = lazy(() => import('@domain/About/AboutPage'));
const TipaltiWithdrawalPage = lazy(() => import('@domain/Account/Withdrawal/TipaltiWithdrawalPage'));
const GameScreen = lazy(() => import('@domain/Tournament/GameScreen'));
const Container = styled('div') `
  font-family: ${({ theme }) => theme.typography.fontFamily};
`;
const MainContent = styled('main') `
  display: flex;

  & > div:last-of-type {
    flex-grow: 1;
    min-width: 0px;
  }
`;
/**
 * WARNING: All pages need to have a single parent component (ie, a wrapping div) so that the 'MainContent' flex
 * renders the content next to the platform first games menu when displayed
 */
const RepeatAppScreenWithdrawalOnly = () => {
    useTrackNavigation();
    const { pathname } = useLocation();
    const history = useHistory();
    const { trackPageView } = useTrackPageView();
    const { authenticated } = useUserState();
    const rootRedirectUrl = useRootRedirectUrl();
    useEffect(() => {
        if (authenticated && (pathname === '/' || pathname === '/tournaments')) {
            history.push(rootRedirectUrl);
        }
        else {
            // required to boot up window.digitalData for adobe analytics, removing it will throw an error in the console and preventing page view tracking from working and login will break;
            trackPageView();
        }
    }, [trackPageView, pathname, authenticated]);
    return (_jsxs(Container, { children: [_jsx(Header, {}), _jsx(MainContent, { children: _jsx(Sentry.ErrorBoundary, { fallback: (errorData) => _jsx(ErrorPage, { error: errorData.error }), children: _jsx(Suspense, { fallback: _jsx("div", {}), children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: ['', '/'], children: _jsx(WithdrawalOnlyLandingPageScreen, {}) }), _jsx(Route, { path: "/user", children: _jsxs(_Fragment, { children: [_jsx(PageTitle, {}), _jsx(UserScreen, {})] }) }), _jsx(PrivateRoute, { exact: true, path: "/account/transactions/withdrawal", children: _jsx(TipaltiWithdrawalPage, {}) }), _jsx(PrivateRoute, { path: "/account", children: _jsx(AccountScreen, {}) }), _jsx(PrivateRoute, { path: "/change-email/confirm/:token", children: _jsx(ChangeEmailConfirmationScreen, {}) }), _jsx(Route, { path: "/about", children: _jsx(AboutPage, {}) }), _jsx(Route, { path: "/:slug", children: _jsx(GameScreen, {}) }), _jsx(Route, { path: "/", children: _jsx(Error404, {}) })] }) }) }) })] }));
};
export default RepeatAppScreenWithdrawalOnly;
